// for login and signup
export const showPassword = (showed,setShowed) => {
    if (showed == 'password') {
      setShowed('text')
    } else {
      setShowed('password')
    }
  }